module.exports = function() {
  return new Worker("/cvat-static/" + "3rdparty/Decoder.worker.c6da711cd3b09536a5ec.js");
};